import { faHome } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ACESSOS } from "../../../../Routes/Acessos";

interface ISelecaoProdutoConfigEnvelopeProps {
    idProduto: number;
}

export default function SelecaoProdutoConfigEnvelope(
    props: ISelecaoProdutoConfigEnvelopeProps
) {
    const { replace } = useHistory();

    return (
        <StickyToolbar icon={faHome}>
            <h2>Produto</h2>
            <div>
                <LazySelect
                    controller={ListarEmpreendimentosController}
                    getDS={(e) => e.DS_EMPREENDIMENTO}
                    getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                    defaultValue={props.idProduto}
                    className="form-control"
                    onChange={(e) => {
                        const idProduto = Number(e.target.value);
                        const link =
                            ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.DS_LINK(
                                idProduto
                            );
                        replace(link);
                    }}
                />
            </div>
        </StickyToolbar>
    );
}
